import Link from '@alltrails/denali/components/Link';
import Typography from '@alltrails/core/components/Typography';
import styles from '../../../components/OldPressCard/styles/styles.module.scss';
import { OldPressReleaseCard } from '@/components/OldPressCard';

const allTrailsDotComLink = (
  <Link href="/" target="_blank">
    AllTrails.com
  </Link>
);

const publicLandsProgramLink = (
  <Link href="https://publiclands.alltrails.com/" target="_blank">
    Public Lands Program
  </Link>
);

const olympicNationalParkLink = (
  <Link href="https://publiclands.alltrails.com/case-studies/fewer-search-and-rescue-incidents/" target="_blank">
    Olympic National Park
  </Link>
);

const publicLandsDotAllTrailsDotComLink = (
  <Link href="https://publiclands.alltrails.com/" target="_blank">
    publiclands.alltrails.com
  </Link>
);

const outdoorIndustryAssociationLink = (
  <Link
    href="https://outdoorindustry.org/press-release/outdoor-participation-grows-for-eighth-consecutive-year/#:~:text=The%20report%20reveals%20that%20the,over%20the%20age%20of%206."
    target="_blank"
  >
    Outdoor Industry Association
  </Link>
);

const pressRelease: OldPressReleaseCard = {
  cardType: 'press-release',
  title: <>AllTrails Announces Public Lands Program with New Trail and Land Management Resources</>,
  date: 'March 5, 2024',
  languages: ['en-US', 'en-GB'],
  modalContent: (
    <>
      <Typography variant="heading400" component="h2">
        <span>AllTrails Announces Public Lands Program with New Trail and Land Management Resources</span>
      </Typography>
      <Typography variant="paragraph100">
        <span>
          San Francisco (March 5, 2024) —AllTrails, the world&apos;s largest and most trusted outdoor platform, today announced its{' '}
          {publicLandsProgramLink}, providing first-of-their-kind capabilities to land managers worldwide. The new program deepens AllTrails’
          commitment to safe and sustainable outdoor exploration by allowing park officials to share time-sensitive updates with AllTrails’ global
          community of more than 60 million trail-goers.
        </span>
        <br />
        <span>
          With more than 420,000 routes mapped across the globe, AllTrails helps people discover trails and explore them confidently. As outdoor
          participation continues to rise,<sup>1</sup> AllTrails also recognizes the need to support public land management efforts in creating safe
          and sustainable access to the outdoors for all.
        </span>
        <br />
        <span>
          AllTrails’ free Public Lands Program provides direct support to over 250 land management agencies and counting. It gives land managers the
          ability to view trail-use insights, edit trail information, and send real-time alerts. As part of the program, agency and park staff have
          access to activity insights from AllTrails’ global and highly-engaged community, which can help them plan programs and maintain trails based
          on detailed trend information.
        </span>
        <br />

        <span>
          “AllTrails is dedicated to getting people outside, and we are committed to the future of responsible outdoor recreation,” said Ron
          Schneidermann, Chief Executive Officer at AllTrails. “The AllTrails Public Lands Program deepens this commitment by working directly with
          land managers and providing them with real-time insights. Our partnership will help park officials improve their visitors’ experience and
          protect our trails for generations to come.”
        </span>
        <br />
        <span>
          The Public Lands Program launches with members that include the U.S. National Park Service, the Nature Conservancy, and multiple national
          and state park agencies. These land managers are already seeing measurable benefits in working with the Public Lands Program.{' '}
          {olympicNationalParkLink}, for example, has seen a 66% decrease in search and rescue-related incidents on trails since partnering with
          AllTrails, noting that it is now better equipped to communicate with visitors regarding pertinent safety and trail updates.
        </span>
        <br />
        <span>
          “Public and private sector partnerships are key to unlocking a more sustainable outdoor experience,” said Pitt Grewe, Head of Public Lands
          Partnerships at AllTrails. “For the first time, we’re combining land-manager expertise and trail data at scale to improve outdoor
          experiences and inform trail-goers. The AllTrails Public Lands Program will support the public lands community in the critical work of
          educating visitors and protecting our wild spaces.”
        </span>
        <br />
        <span>
          In addition to the Public Lands Program, AllTrails is a 1% for the Planet partner, contributing 1% of its annual revenue to organizations
          that protect and increase equitable access to the outdoors.
        </span>
        <br />
        <span>
          For more information on the AllTrails Public Lands Program or to inquire about partnership, visit {publicLandsDotAllTrailsDotComLink}
        </span>
        <br />
        <span>About AllTrails</span>
        <br className={styles.noMargin} />
        <span>
          AllTrails helps you find your way outside with detailed reviews and inspiration from a global community of trail-goers. Every day, AllTrails
          helps people have healthy, authentic experiences and a deeper appreciation of the outdoors. AllTrails was awarded Apple’s 2023 iPhone App of
          the Year and a Google Play Best of 2023 honorable mention. Download AllTrails in the App Store or head to {allTrailsDotComLink} to learn
          more.
        </span>
        <br />
        <span>
          <sup>1</sup> According to the {outdoorIndustryAssociationLink}, since 2018, there has been an increase of over 50% in outdoor participation.
        </span>
      </Typography>
    </>
  )
};

export default pressRelease;
